import styled from 'styled-components';

const FiltersStyle = styled.div`
	.selected-inner-wrapper {
		margin-top: var(--sp4x);
		display: flex;
		flex-wrap: wrap;
		row-gap: calc(var(--sp4x) / 2);
		column-gap: var(--sp4x);

		i {
			cursor: pointer;
		}
	}

	.selected-block {
		display: flex;
		align-items: center;
	}

	.selected-item-close {
		margin-left: var(--sp1-5x);
	}

	.is-desktop {
		width: fit-content;
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		.selected-wrapper {
			padding-bottom: var(--sp2x);
		}

		.selected-inner-wrapper,
		.is-mobile {
			margin-top: var(--sp1x);
		}

		.is-desktop {
			display: none;
		}

		.is-mobile {
			width: fit-content;
		}
	}
`;

export default FiltersStyle;
